
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { IHeatmap } from "@/models/heatmap";
import { mapState } from "vuex";

export default defineComponent({
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  computed: {
    ...mapState(["isLoadingHeatmap"]),
    state() {
      return {
        activeHeatmaps: this.$store.state.activeHeatmaps,
        currentSlide: this.$store.state.currentSlide,
        isLoadingHeatmap: this.$store.state.isLoadingHeatmap,
      };
    },
  },
  methods: {
    getLowLabelFor(heatmap: IHeatmap) {
      return this.t(heatmap.config.lowLabel || "heatmaps.low_probability");
    },
    getHighLabelFor(heatmap: IHeatmap) {
      return this.t(heatmap.config.highLabel || "heatmaps.high_probability");
    },
  },
});
